import { Add, Delete, Link } from "@mui/icons-material";
import { Alert, Avatar, Divider, Grid, IconButton, Stack, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import "moment/locale/ca";
import PageAdmin from "../../components/PageAdmin";
import Loading from "../../components/Loading";
import { Finals, Inscrits, Opcions } from "../../db/firebase";
import CustomButton from "../../components/CustomButton";
import { useSnackbar } from "notistack";
import { comparses } from "../../data/comparses";
import theme from "../../theme";
import { DialogConfirmar } from "../../components/DialogConfirmar";

export default function OpcionsAdmin() {
	const [loadingO, errorO, opcions, getOpcions, editarOpcions] = Opcions();
	const [loadingF, errorF, finals, getFinals, addFinals, removeFinals, removeInscrits] = Finals();

	const [openSorteig, setOpenSorteig] = useState(false);
	const [openInscrits, setOpenInscrits] = useState(false);
	const [openObrir, setOpenObrir] = useState(false);
	const [dataAssaig, setDataAssaig] = useState(opcions?.data_assaig);
	const [dataPatum, setDataPatum] = useState(opcions?.data_patum);
	const [comparsesEdat, setComparsesEdat] = useState(opcions?.comparses);
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();

	useEffect(() => {
		setComparsesEdat(opcions?.comparses);
	}, [opcions]);

	useEffect(() => {
		getOpcions();
	}, []);

	const editarOpcio = (opcio, val) => {
		editarOpcions(opcio, val);
		enqueueSnackbar("Guardat", {
			variant: "success",
		});
	};

	const editarComparses = () => {
		console.log(comparsesEdat);
		editarOpcions("comparses", comparsesEdat);
		enqueueSnackbar("Guardat", {
			variant: "success",
		});
	};

	const editEdat = (id, edatMin, edatMax, max) => {
		let edatsNew = { ...comparsesEdat, [id]: { edatMin: Number(edatMin), edatMax: Number(edatMax), max: Number(max) } };
		setComparsesEdat(edatsNew);
	};

	const sorteigReset = () => {
		setOpenSorteig(false);
		removeFinals();
		enqueueSnackbar("Sorteig eliminat", {
			variant: "success",
		});
	};

	const inscritsReset = () => {
		setOpenInscrits(false);
		removeInscrits();
		enqueueSnackbar("Inscrits eliminats", {
			variant: "success",
		});
	};

	return (
		<PageAdmin title="Opcions">
			<Loading loading={loadingO}>
				{!opcions?.obertes && (
					<Box p={3}>
						<Alert severity="warning">Inscripcions tancades </Alert>
					</Box>
				)}
				<Grid spacing={2} container mt={1} p={3}>
					<Grid item md={6} xs={12}>
						<Box className={classes.bloc}>
							<Typography variant="h3" mb={2}>
								Dates
							</Typography>
							<Box display={"flex"}>
								<TextField
									label="Data primer assaig"
									name="data_assaig"
									value={dataAssaig}
									onChange={(e) => setDataAssaig(e.target.value)}
									fullWidth
									defaultValue={opcions?.data_assaig}
									type="date"
								/>
								<CustomButton title={"Guardar"} onClick={() => editarOpcio("data_assaig", dataAssaig)} />
							</Box>
							<Box display={"flex"} my={2}>
								<TextField
									label="Data Patum"
									name="data_patum"
									value={dataPatum}
									onChange={(e) => setDataPatum(e.target.value)}
									fullWidth
									defaultValue={opcions?.data_patum}
									type="date"
								/>
								<CustomButton title={"Guardar"} onClick={() => editarOpcio("data_patum", dataPatum)} />
							</Box>
						</Box>
						<Box className={classes.bloc} mt={3}>
							<Typography variant="h3" mb={2}>
								Accions
							</Typography>
							<Stack direction={"row"} spacing={2}>
								<CustomButton
									title={opcions?.obertes ? "Tancar inscripcions" : "Obrir inscripcions"}
									onClick={() => setOpenObrir(true)}
									fullWidth
									light
								/>
								<CustomButton title={"Eliminar sorteig"} onClick={() => setOpenSorteig(true)} fullWidth />
								<CustomButton title={"Eliminar inscrits"} onClick={() => setOpenInscrits(true)} fullWidth />
							</Stack>
						</Box>
					</Grid>
					<Grid item md={6} xs={12}>
						<Box className={classes.bloc}>
							<Typography variant="h3" mb={2}>
								Restriccions d'edat per comparsa
							</Typography>
							{Object?.entries(comparsesEdat ?? [])?.map((comp) => {
								const Comparsa = comparses?.find((c) => c.id === comp?.[0]);
								return (
									<Box display={"flex"} mb={2} alignItems={"center"}>
										<Box
											display={"flex"}
											style={{
												backgroundColor: theme.palette.primary.main,
												borderRadius: 50,
												marginRight: 10,
												width: 70,
												height: 70,
												padding: 5,
											}}
										>
											<img src={Comparsa.png} alt={Comparsa.nom} style={{ width: 70, height: 70 }} />
											{/* <Comparsa.icon style={{ fill: "white", width: 70, height: 70 }} /> */}
										</Box>

										<TextField
											label={"Edat mínma " + comparses?.find((c) => c.id === comp?.[0]).nom}
											name={comp?.[0]}
											value={comparsesEdat[comp?.[0]]?.edatMin}
											onChange={(e) =>
												editEdat(comp?.[0], e.target.value, comparsesEdat[comp?.[0]]?.edatMax, comparsesEdat[comp?.[0]]?.max)
											}
											fullWidth
											type="number"
											InputLabelProps={{
												shrink: true,
											}}
										/>
										<TextField
											label={"Edat màxima " + comparses?.find((c) => c.id === comp?.[0]).nom}
											name={comp?.[0]}
											value={comparsesEdat[comp?.[0]]?.edatMax}
											onChange={(e) =>
												editEdat(comp?.[0], comparsesEdat[comp?.[0]]?.edatMin, e.target.value, comparsesEdat[comp?.[0]]?.max)
											}
											fullWidth
											type="number"
											InputLabelProps={{
												shrink: true,
											}}
										/>
										<TextField
											label={"Màxim inscrits " + comparses?.find((c) => c.id === comp?.[0]).nom}
											name={comp?.[0]}
											value={comparsesEdat[comp?.[0]]?.max}
											onChange={(e) =>
												editEdat(comp?.[0], comparsesEdat[comp?.[0]]?.edatMin, comparsesEdat[comp?.[0]]?.edatMax, e.target.value)
											}
											fullWidth
											type="number"
											InputLabelProps={{
												shrink: true,
											}}
										/>
									</Box>
								);
							})}
							<CustomButton title={"Guardar"} onClick={editarComparses} />
						</Box>
					</Grid>
				</Grid>
			</Loading>
			<DialogConfirmar
				open={openSorteig}
				setOpen={setOpenSorteig}
				onClick={sorteigReset}
				boto={"Eliminar"}
				text={"Segur que vols eliminar els resultats del sorteig?"}
			/>
			<DialogConfirmar
				open={openInscrits}
				setOpen={setOpenInscrits}
				onClick={inscritsReset}
				boto={"Eliminar"}
				text={"Segur que vols eliminar tots els inscrits?"}
			/>
			<DialogConfirmar
				open={openObrir}
				setOpen={setOpenObrir}
				onClick={() => {
					editarOpcio("obertes", opcions?.obertes ? 0 : 1);
					setOpenObrir(false);
				}}
				boto={opcions?.obertes ? "Tancar inscripcions" : "Obrir inscripcions"}
				text={"Segur que vols editar la obertura d'inscripcions?"}
			/>
		</PageAdmin>
	);
}

const useStyles = makeStyles((theme) => ({
	bloc: {
		backgroundColor: "white",
		padding: 20,
		borderRadius: 20,
	},
	codi: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		padding: 10,
		marginBottom: 10,
		border: "1px solid lightgray",
		boxShadow: "#00000020 1px 1px 10px 1px ",
		borderRadius: 5,
	},
	linia: {
		borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
		padding: 10,
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
	},
}));
